import {faces} from "../face";
import {textConvertImg} from "./imgUtils";

//表情解析
export const faceAnalysis = function (content, eClass) {
  return content.replace(/face\[[^\s\[\]]+?]/g, function (str) {
    let item = faces[str];
    if (item) {
      return '<img class="' + (eClass ? eClass : "") + '" alt="' + item.code + '" title="' + item.title + '" src="' + item.url + '"/>';
    } else {
      return str;
    }
  })
};

export const atAnalysis = function (content, eClass) {
  return content.replace(/@\[\d{18,24}\|.{1,12}]/g, function (str) {
    let inner = str.substring(2, str.length - 1);
    let split = inner.split('|');
    if (split[0] && split[1]) {
      return '<img class="' + (eClass ? eClass : "") + '" uid="' + split[0] + '" alt="@[' + split[0] + ']" src="' + textConvertImg('@' + split[1]) + '"/>';
    }
    return '<img class="' + (eClass ? eClass : "") + '" alt="@[' + split[0] + ']" src="' + textConvertImg('@' + split[0]) + '"/>';
  })
};



// WEBPACK FOOTER //
// ./src/js/utils/textAnalysis.js